<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.49996 6.0533V7.0533" stroke="#2A3243" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M11.5 6.0533V7.0533" stroke="#2A3243" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M7.83337 9.0647H8.16671C8.53471 9.0647 8.83337 8.76603 8.83337 8.39803V6.0647" stroke="#2A3243"
    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M10.6614 10.7713C9.46802 11.9646 7.53269 11.9646 6.33936 10.7713" stroke="#2A3243" stroke-width="1.5"
    stroke-linecap="round" stroke-linejoin="round" />
  <path d="M5.55867 2H3.83333C3.09667 2 2.5 2.59667 2.5 3.33333V5.05867" stroke="#2A3243" stroke-width="1.5"
    stroke-linecap="round" stroke-linejoin="round" />
  <path d="M11.4414 14H13.1667C13.9034 14 14.5001 13.4033 14.5001 12.6667V10.9413" stroke="#2A3243" stroke-width="1.5"
    stroke-linecap="round" stroke-linejoin="round" />
  <path d="M2.5 10.9413V12.6667C2.5 13.4033 3.09667 14 3.83333 14H5.55867" stroke="#2A3243" stroke-width="1.5"
    stroke-linecap="round" stroke-linejoin="round" />
  <path d="M14.5001 5.05867V3.33333C14.5001 2.59667 13.9034 2 13.1667 2H11.4414" stroke="#2A3243" stroke-width="1.5"
    stroke-linecap="round" stroke-linejoin="round" />
</svg>
